import { render, staticRenderFns } from "./CompanyKeys.vue?vue&type=template&id=2bc51786&"
import script from "./CompanyKeys.vue?vue&type=script&lang=js&"
export * from "./CompanyKeys.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports